import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_checked-circle-invert",
  "use": "svg_checked-circle-invert-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg_checked-circle-invert\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 0a8 8 0 1 0 8 8 8.008 8.008 0 0 0-8-8ZM5.513 7.696 6.77 8.953l3.718-3.718a.835.835 0 1 1 1.18 1.18l-.08.08a.75.75 0 0 1-.085.101L7.31 10.788a.754.754 0 0 1-1.069 0L5.07 9.617a.76.76 0 0 1-.041-.045l-.696-.695a.834.834 0 1 1 1.18-1.18Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol